// Service for the attendance-monitoring counters.
// GET /attendance/monitoring/counters?companyIds=...&areaIds=...&includeWithoutSchedule=...
// Accepts the same request shape as the monitoring filters panel
// (LC_MonitoringFiltersIn) and returns the four counters (LC_MonitoringCountersOut).

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';
import type { LC_MonitoringFiltersIn } from '../types/monitoringFilters.types';
import type { LC_MonitoringCountersOut } from '../types/monitoringCounters.types';


export class MonitoringCountersService {
  async get(
    filters: LC_MonitoringFiltersIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_MonitoringCountersOut>> {
    const query = buildQueryString({ ...filters });
    const endpoint = `${API_CONFIG.ENDPOINTS.MONITORING_COUNTERS}${query}`;

    return apiClient.get<LC_MonitoringCountersOut>(endpoint, { signal });
  }
}

export const monitoringCountersService = new MonitoringCountersService();
